import React, { useState } from 'react';
import { ListChecks, ChevronDown, ChevronUp } from 'lucide-react';
import {
  Command, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem
} from '../ui/command';

const GROUP_LABELS = {
  corba: 'Çorbalar', ana_yemek: 'Ana Yemekler', yardimci_yemek: 'Yardımcı Yemekler', salata: 'Salatalar & Mezeler', diger: 'Diğer'
};

export const CateringProductPicker = ({ products, preferredGroup, onSelect, testId }) => {
  const [open, setOpen] = useState(false);
  const order = [preferredGroup, ...Object.keys(GROUP_LABELS).filter(g => g !== preferredGroup)];

  const pick = (p) => { onSelect(p); setOpen(false); };

  return (
    <div className="mb-2">
      <button
        type="button"
        onClick={() => setOpen(o => !o)}
        className="w-full flex items-center justify-between gap-2 px-3 py-2 rounded-lg border border-basil/40 bg-basil/5 text-sm text-basil font-medium hover:bg-basil/10 transition-colors"
        data-testid={`${testId}-toggle`}
      >
        <span className="flex items-center gap-2"><ListChecks className="w-4 h-4" />Ürün listesinden seç ({products.length})</span>
        {open ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
      </button>
      {open && (
        <Command className="mt-1 border rounded-lg bg-white" data-testid={`${testId}-panel`}>
          <CommandInput placeholder="Kod veya ürün adı ara..." data-testid={`${testId}-search`} />
          <CommandList className="max-h-64">
            <CommandEmpty>Ürün bulunamadı</CommandEmpty>
            {order.map(g => {
              const list = products.filter(p => p.group === g);
              if (!list.length) return null;
              return (
                <CommandGroup key={g} heading={`${GROUP_LABELS[g]} (${list.length})`}>
                  {list.map(p => (
                    <CommandItem key={p.code} value={`${p.code} ${p.name}`} onSelect={() => pick(p)} data-testid={`${testId}-option-${p.code}`}>
                      <span className="font-mono text-xs text-charcoal/50 mr-2 shrink-0">{p.code}</span>
                      <span className="truncate">{p.name}</span>
                      {p.unit && <span className="ml-auto text-[10px] text-charcoal/40 shrink-0">{p.unit}</span>}
                    </CommandItem>
                  ))}
                </CommandGroup>
              );
            })}
          </CommandList>
        </Command>
      )}
    </div>
  );
};

export default CateringProductPicker;
